export default {"src":"/_next/static/media/mitigate-privacy-risk.aee6c76a.svg","height":1004,"width":1004,"blurWidth":0,"blurHeight":0};